import { useLocation } from 'react-router-dom'
import { useRecoilState } from 'recoil'
import { askArwenEnabledState, isUserAdminState } from '../../store/DomainStore'
import ActiveNavIndicator from './ActiveNavIndicator'
import NavigationItem from './NavigationItem'
import { NAV_TITLE_ASK_ARWEN, getNavigationItems } from './navigation-data'
import { whichPageAreWeOn } from './page-name'

type Props = {
    sidebarOpen: boolean
}

function SidebarNav(props: Props) {
    const { sidebarOpen } = props
    const [admin] = useRecoilState(isUserAdminState)
    const [askArwenEnabled] = useRecoilState(askArwenEnabledState)
    const location = useLocation()

    // Which sidebar nav item do we want to highlight?
    // Lets split the pathname into its components
    const paths = location.pathname.split('/')
    const pages = whichPageAreWeOn(paths)

    // Get the navigation items - by passing the page booleans these functions will highlight the correct nav item
    const navigation = getNavigationItems(
        pages.onHomePage,
        pages.onContentSearchPage,
        pages.onTeamPage,
        pages.onReportPage,
        pages.onAskArwenPage
    )

    // Re-measure the active-item indicator whenever the route or the set/position
    // of nav items can change. Kept as a string so the effect dependency is stable.
    const navSignature = [location.pathname, sidebarOpen, admin, askArwenEnabled].join('|')

    return (
        <nav className="relative flex-1 px-3 pb-4">
            <ActiveNavIndicator signature={navSignature} />
            <div className="space-y-0.5">
                {navigation.map((item) => {
                if (item.name === NAV_TITLE_ASK_ARWEN && !askArwenEnabled) {
                    // User does not have this enabled - we don't want to show this link
                    return <div key={item.name}></div>
                }
                return (
                    <div key={item.name}>
                        <NavigationItem item={item} sidebarOpen={sidebarOpen} key={item.name} />
                    </div>
                )
                })}
            </div>
        </nav>
    )
}

export default SidebarNav
